import { getEnv } from './env'
import { region, getQuery } from './utils'
import { getLocation } from '@/utils/ssrCompatible'
import { isInCoinsApp } from '@/utils/utils'
import { appReqBaseUrl } from '@/utils/native'
import { countryOfCluster } from '@/config/country'

// let isChecking = '' // 健康检查标识
let locationParams = {}

export const getHost = () => {
  const { host, protocol } = getLocation()
  return `${protocol}//${host}`
}

export function switchTestHost() {
  const serverId = getQuery('serverid') || '3' // 国内测试域名
  if (process.client && isInCoinsApp()) {
    const baseUrl = appReqBaseUrl()
    if (baseUrl) return baseUrl
  }
  const hostMaps = {
    1: 'staging-dev1-oversea-api.toplupe.com',
    2: 'staging-dev1-oversea-api.toplupe.com',
    3: 'staging-dev1-oversea-api.toplupe.com',
    4: 'staging-dev1-oversea-api.toplupe.com',
  }
  return hostMaps[serverId]
}

export function switchEnv() {
  const env = getQuery('env')
  const envMaps = ['online', 'preview', 'test']
  return envMaps.includes(env) && env
}

export const getServerHost = (ssrLocationParams) => {
  if (process.server) {
    // isChecking = ssrLocationParams?.health_checks || ''
    locationParams = getLocation(ssrLocationParams)
  } else {
    locationParams = window.location
    // isChecking = ''
  }

  const { protocol, hostname } = locationParams

  let HTTP = ''

  // 巴西集群
  const topServerHostMap = {
    online: `${protocol}//br-api.toplupe.com`,
    preview: `${protocol}//preview-br-api.toplupe.com`,
    previewSrv: `http://preview-br-api.toplupe.srv`,
    test: `${HTTP || protocol}//${switchTestHost()}`,
  }
  // 新加坡集群
  const topServerHostMap_sgp = {
    online: `${protocol}//sgp-api.toplupe.com`,
    preview: `${protocol}//preview-sgp-api.toplupe.com`,
    previewSrv: `http://preview-sgp-api.toplupe.srv`,
    test: `${HTTP || protocol}//${switchTestHost()}`,
  }
  // 印尼
  const topServerHostMap_id = {
    online: `${protocol}//id-api.toplupe.com`,
    preview: `${protocol}//preview-id-api.toplupe.com`,
    previewSrv: `http://preview-id-api.toplupe.srv`,
    test: `${HTTP || protocol}//${switchTestHost()}`,
  }
  // 印度集群
  const topServerHostMap_in = {
    online: `${protocol}//in-api.toplupe.com`,
    preview: `${protocol}//preview-in-api.toplupe.com`,
    previewSrv: `${protocol}//preview-in-api.toplupe.com`,
    test: `${protocol}//${switchTestHost()}`,
  }
  // 俄罗斯集群
  const topServerHostMap_ru = {
    online: `${protocol}//ru-api.toplupe.com`,
    preview: `${protocol}//preview-ru-api.toplupe.com`,
    previewSrv: `http://preview-ru-api.toplupe.srv`,
    test: `${HTTP || protocol}//${switchTestHost()}`,
  }
  // 法兰克福集群
  const topServerHostMap_de = {
    online: `${protocol}//de-api.toplupe.com`,
    preview: `${protocol}//preview-de-api.toplupe.com`,
    previewSrv: `http://preview-de-api.toplupe.srv`,
    test: `${HTTP || protocol}//${switchTestHost()}`,
  }
  const clusterMaps = {
    br: topServerHostMap,
    sgp: topServerHostMap_sgp,
    id: topServerHostMap_id,
    ru: topServerHostMap_ru,
    de: topServerHostMap_de,
    in: topServerHostMap_in,
  }
  const clusterName = (countryOfCluster() || {})[region(ssrLocationParams)]
  // sgp集群备用域名
  const sgpBackupHost = 'https://sgp-api.toplupe.life'
  if (hostname.indexOf('toplupe.life') > -1 && clusterName === 'sgp') {
    return sgpBackupHost
  }

  // todo 重新上线更新域名后没有onlineSrv域名
  // if (matrixClusterName && isChecking) {
  //   const _clusterName = setCluster({
  //     cluster: matrixClusterName,
  //     locations: locationParams,
  //   })
  //   return clusterMaps[_clusterName]['onlineSrv']
  // }
  return clusterMaps[clusterName][getEnv(ssrLocationParams)]
}
